import React from 'react'

const Footer = () => {
  return (
    <div>
       <footer className="bg-gray-900 text-white py-10">
            <div className="container mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                
                {/* <div>
                    <h3 className="text-lg font-semibold mb-4">Adopt a Pet</h3>
                    <ul className="space-y-2">
                        <li><a href="#" className="hover:underline">Blog</a></li>
                        <li><a href="#" className="hover:underline">Career</a></li>
                        <li><a href="#" className="hover:underline">Support</a></li>
                        <li><a href="#" className="hover:underline">About Us</a></li>
                    </ul>
                </div> */}

                {/* Section: Services */}
                <div>
                    <h3 className="text-lg font-semibold mb-4">Home Services</h3>
                    <ul className="space-y-2">
                        <li><a href="#" className="hover:underline">Pet Grooming</a></li>
                        <li><a href="#" className="hover:underline">Dog Training</a></li>
                        <li><a href="#" className="hover:underline">Dog Walking</a></li>
                        <li><a href="#" className="hover:underline">Home Vet Visit</a></li>
                        <li><a href="#" className="hover:underline">Pet Relocation</a></li>
                        <li><a href="#" className="hover:underline">Pet Insurance</a></li>
                        <li><a href="#" className="hover:underline">Dog Training Course</a></li>
                        <li><a href="#" className="hover:underline">Pet Boarding & Sitting</a></li>
                        <li><a href="#" className="hover:underline">Online Vet Consultation</a></li>
                    </ul>
                </div>

            
                <div>
                    <h3 className="text-lg font-semibold mb-4">Partner</h3>
                    <ul className="space-y-2">
                        <li><a href="#" className="hover:underline">Become a Groomer</a></li>
                        <li><a href="#" className="hover:underline">Become a Trainer</a></li>
                        <li><a href="#" className="hover:underline">Become a Dog Walker</a></li>
                        <li><a href="#" className="hover:underline">Become a Pet Boarder</a></li>
                        <li><a href="#" className="hover:underline">Pet Grooming Course</a></li>
                        <li><a href="#" className="hover:underline">Pet Store Franchise</a></li>
                    </ul>
                </div>

                
                <div>
                    <h3 className="text-lg font-semibold mb-4">Pet Stores</h3>
                    <ul className="space-y-2">
                        <li><a href="#" className="hover:underline">Online Pet Shop</a></li>
                        <li><a href="#" className="hover:underline">Buy Membership</a></li>
                        <li><a href="#" className="hover:underline">Customer Reviews</a></li>
                        <li><a href="#" className="hover:underline">Grooming Service Reviews</a></li>
                        <li><a href="#" className="hover:underline">Report Animal Abuse</a></li>
                        <li><a href="#" className="hover:underline">Download Mobile App</a></li>
                    </ul>
                </div>

                
                <div>
                    <h3 className="text-lg font-semibold mb-4">Policy</h3>
                    <ul className="space-y-2">
                        <li><a href="#" className="hover:underline">Privacy Policy</a></li>
                        <li><a href="#" className="hover:underline">Refund Policy</a></li>
                        <li><a href="#" className="hover:underline">Cancellation Policy</a></li>
                        <li><a href="#" className="hover:underline">Terms & Conditions</a></li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-gray-700 mt-8 pt-4 text-center text-sm">
                <p>&copy; 2024 Adopt a Pet. All rights reserved.</p>
            </div>
        </footer>
    </div>
  )
}

export default Footer
